import axios from 'axios';
import { requestInterceptor, responseInterceptor, errorInterceptor } from './interceptors';
import {localapiurl} from '../constant';

// Create an Axios instance
const axiosInstance2 = axios.create({
  baseURL: `${localapiurl}`,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// Apply interceptors
axiosInstance2.interceptors.request.use(requestInterceptor, (error) => Promise.reject(error));
axiosInstance2.interceptors.response.use(responseInterceptor, errorInterceptor);

export default axiosInstance2;